import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { Environment } from 'src/app/classes/environment';
import { Folder, Group, GroupFolder } from 'src/app/classes/fileInfo';
import { FileService } from 'src/app/services/file.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
	selector: 'app-file-group-editor',
	templateUrl: './file-group-editor.component.html',
	styleUrls: ['./editor.component.css']
})
export class FileGroupEditorComponent implements OnInit {


	private _group = new Group();
	@Input() set group( val: Group ) {
		this._group = val;
		this.updateValueForm();
	}
	get group() { return this._group; }

	formG1 = this.formBuilder.group({});
	formG2 = this.formBuilder.group({});
	myInputs: { [key: string]: DataInput } = {};

	@Input() allFolders: Folder[] = [];
	foldersInTheGroup: Folder[] = [];

	@Output() done = new EventEmitter<Group>();

	gfs: GroupFolder[] = [];

	readonly DOT = "--[-ThisIsADot-]--";

	bSaving = false;


	constructor(
		private formBuilder: UntypedFormBuilder,
		private fileService: FileService,
		@Inject('environment') private environment: Environment,
		private matSnackBar: MatSnackBar,
	) {}


	ngOnInit() {

		for( let dataInput of this.environment.group ) {
			this.myInputs[ dataInput.id ] = dataInput;
		}

		for( const folder of this.allFolders ) {
			// console.log( "folderPath", folder.folderPath )
			this.formG2.addControl( this.replaceDots( folder.folderPath ), new UntypedFormControl( "", [] ) );
		}

		setTimeout( () => {

			if( this._group.gruppenId ) {

				this.fileService.getFoldersByGroup( this._group.gruppenId ).subscribe( folders => {
					this.foldersInTheGroup = folders;
					if( !folders || !folders.length ) return;

					this.fileService.getGroupFolders( this._group.gruppenId ).subscribe( gfs => {
						this.gfs = gfs;
						// console.log( "this.formG2.controls", this.formG2.controls )
						for( const gf of gfs ) {
							const folder = this.foldersInTheGroup.find( f => f.folderId == gf.folderId );
							if( !folder ) {
								console.log( "FOLDER NOT FOUND", folder, gf.folderId, gf )
								this.matSnackBar.open( 'ein Fehler ist aufgetreten', '', { duration: 5000 } );
								continue;
							}
							this.formG2.get( this.replaceDots(folder.folderPath) )?.setValue( true );
						}
					} );

				});
			}

			this.updateValueForm();

		}, 1 );

	}


	updateValueForm() {

		if( this.formG1.get( 'gruppenname' ) ) {	// the formgroup is already initialized
			this.formG1.reset();
			this.formG1.patchValue( this._group );
		}

	}

	cancel() {
		this.done.emit( new Group() );
	}

	reset() {
		console.log( 'reset()', this.formG1 )
		this.updateValueForm();
	}

	save() {

		const elementToSave = { ...this._group };

		const f = this.formG1.value;
		for( const field in this.myInputs ) {
			(elementToSave[ field as keyof Group ] as any) = f[ field ];
		}

		this.bSaving = true;
		this.formG1.disable();
		this.formG2.disable();

		this.fileService.saveGroup( elementToSave ).subscribe( elementSaved => {

			if( !elementSaved || !elementSaved.gruppenId ) {
				this.bSaving = false;
				this.formG1.enable();
				this.formG2.enable();
				return;
			}

			for( const property in elementSaved ) {
				if( elementSaved.hasOwnProperty(property) ) {
					this._group[ property ] = elementSaved[ property ];
				}
			}

			const gfs: GroupFolder[] = [];
			console.log( 'this.formG2.controls', this.formG2.controls )
			for( const ctrlId in this.formG2.controls ) {
				const c = this.formG2.get( ctrlId );
				console.log( "folderPath", ctrlId, c )
				if( !c ) continue;

				const folderPath = this.reinsertDots( ctrlId );
				const folder = this.foldersInTheGroup.find( f => f.folderPath == folderPath );
				const gf = this.gfs.find( o => o.folderId == folder?.folderId ) || new GroupFolder();
				gf.folderPath = folderPath;
				gf.gruppenId = this._group.gruppenId;
				gf.unassign = !c.value;
				gfs.push( gf );
			}
			this.fileService.setGroupFolders( gfs ).subscribe( gfsSaved => {

				this.bSaving = false;
				this.formG1.enable();
				this.formG2.enable();

				if( gfsSaved ) {
					this.gfs = gfsSaved;
					this.done.emit( this._group );
				}
			});

		});

	}


	replaceDots( str: string ): string {
		if( !str || !str.length ) return "";
		return str.split( "." ).join( this.DOT );
	}

	reinsertDots( str: string ): string {
		if( !str || !str.length ) return "";
		return str.split( this.DOT ).join( "." );
	}

}
